import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { SiilaTranslationService } from "../../core/services/siila-translation.service";
import { I18nService } from "./i18n.service";

@Injectable()
export class NewsNavigateService {
  currentCode = environment.platformId;
  constructor(
    private router: Router,
    private siilaTranslationService: SiilaTranslationService,
    private i18: I18nService
  ) {}

  openNews(
    id: number,
    title,
    isMobile,
    pageSize,
    isIOS,
    browserLang,
    condition = false,
    latamCountry?
  ) {
    if (isMobile) {
      localStorage.setItem("scrollPosition", window.pageYOffset.toString());
      localStorage.setItem("pageSize", pageSize.toString());
    }

    if (isIOS) {
      this.router.navigateByUrl(this.addUrl(browserLang, title, id));
    } else {
      if (condition) {
        window.open(
          `${
            this.currentCode == "co"
              ? latamCountry == "latamBr"
                ? environment.applicationURLBr + "/"
                : environment.applicationURLMx + "/"
              : ""
          }${this.addUrl(browserLang, title, id)}`,
          isMobile ? "_self" : "_blank"
        );
      } else {
        window.open(
          this.addUrl(browserLang, title, id),
          isMobile ? "_self" : "_blank"
        );
      }
    }
  }

  addUrl(browserLang, title, id) {
    const sts = this.siilaTranslationService;
    const basePath = `${sts.getNewsSlugPrefix(browserLang)}/${sts.slugify(
      sts.getTranslation(title)
    )}/${id}`;
    return sts.buildLocalizedPath(basePath);
  }

  openNewsSearch(isMobile, keyword) {
    const encodedKeyword = encodeURIComponent(keyword);
    window.open(
      this.siilaTranslationService.buildLocalizedPath(
        `search_news?keyword=${encodedKeyword}`
      ),
      isMobile ? "_self" : "_blank"
    );
  }

  goNewsTags(tag, color, stateName, isMobile) {
    const basePath = `resource/tags/${this.siilaTranslationService.getTranslation(
      stateName
    )}/${tag.id}/${color}`;
    window.open(
      this.siilaTranslationService.buildLocalizedPath(basePath),
      isMobile ? "_self" : "_blank"
    );
  }

  goHome(latam = false, isMobile?) {
    window.open(
      latam
        ? this.siilaTranslationService.buildCrossCountryUrl(
            "latam",
            "/resource"
          )
        : this.siilaTranslationService.buildLocalizedPath("resource"),
      isMobile ? "_self" : "_blank"
    );
  }
}
